import {
  Box,
  Typography,
  AppBar,
  CardMedia,
  Divider,
  IconButton,
  Grid,
  LinearProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  ApplicationProps,
  Broker,
  BrokerList,
  Declaration,
  Document,
  esignApplicationResponse,
  Groups,
  GroupSignatories,
  individuals_Poa_nonIndividuals_Documents,
  poaAuthorisedSignatoriesType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  getApplicationDetailsWithRefId,
  sendEsignAuthorised,
} from '../../redux-store/actions/onBoarding';
import { useHistory } from 'react-router';
import { RootStateType } from '../../redux-store/reducers';
import { Footer, ListView } from '../commonComponents';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
  APPLICATION_TYPE,
  directInvestmentDisabledDate,
  ESIGN_STATUS,
  nidi2AInvestmentDeclarationStartDate,
  RiskProfileEnabled,
  UboCategoryMaster,
} from '../../utils/constant';
import {
  getBrokers,
  provideConsentApplication,
  getDocuments,
  isFormValidForSubmission,
  nonIndividualFormValidForSubmission,
} from '../../redux-store/actions/application';
import { showError } from '../../redux-store/actions/auth';
import { nationaliyType } from '../../redux-store/types/mdms';
import { Formik } from 'formik';
import { Notes, SubHeading } from '../investors/components';
import LoadingButton from '@mui/lab/LoadingButton';
import { NonIndividualApplicationLayout } from '../NonIndividualApplicationDetails';
import MFCheckbox from '../../lib/formik/Checkbox';
import { getNationalityList, riskProfileMasterData } from '../../redux-store/actions';
import {
  checkforDirectInvestment,
  checkIfApplicationIsNonIndividual,
  checkIfApplicationIsNonIndividualPOA,
  checkIfSchemeNIDI2,
  checkValidationBasedOnDate,
} from '../../utils/utilityFunctions';
import { ApplicationDetailsCommonLayout } from '../ApplicationDetails';
import {
  DeclarationMaster,
  esignDeclaration,
  nidi2AInvestmentDeclarationNode,
} from '../Investments/Declarations';
import { styles } from '../../Styles/styles';
import { DeclarationErrors } from '../../redux-store/middleware';
import {
  useFeatureToggles,
  useMdmsBrokerListData,
  useMdmsCountryData,
  useMdmsDocumentData,
  useMdmsRiskProfileData,
  useMdmsTopUpDocumentData,
} from '../../utils/useDataMdms';
import { Location } from 'history';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

const initialValues: Declaration = {
  directInvestment: false,
  indirectInvestment: false,
  individualUbo: false,
  noIndividualOwnership: false,
  nonIndividualUbo: false,
  nidi2AInvestmentDeclaration: false,
};

export const getGroupAuthorizedSignatories = (
  authorizedSignatories: Groups[]
): GroupSignatories[] => {
  return authorizedSignatories
    ?.map((_group) => _group.groupsignatories)
    ?.flat() as GroupSignatories[];
};

export const getPoaAuthorizedSignatories = (
  authorizedSignatories: poaAuthorisedSignatoriesType[]
): poaAuthorisedSignatoriesType[] => {
  return authorizedSignatories?.flat() as poaAuthorisedSignatoriesType[];
};

const getAuthorisedSignatories = (application: ApplicationProps): Declaration[] => {
  if (application?.hasPOA) {
    return getPoaAuthorizedSignatories(
      application?.distributor?.authorisedsignatories as poaAuthorisedSignatoriesType[]
    )?.map((signatory) => signatory?.declaration) as Declaration[];
  } else {
    return getGroupAuthorizedSignatories(application?.groups as Groups[])?.map(
      (signatory) => signatory?.declaration
    ) as Declaration[];
  }
};

export const validDeclaration = (
  decalaration: Declaration,
  application: ApplicationProps
): boolean => {
  if (
    !application?.distributor_id
      ? checkforDirectInvestment(
          application?.createdAt || '',
          application?.distributorName || ''
        ) && !decalaration.directInvestment
      : false && !decalaration.indirectInvestment
  ) {
    return true;
  } else if (
    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL &&
    ((!decalaration?.noIndividualOwnership && !application?.ubos?.length) ||
      (!decalaration?.individualUbo &&
        application?.ubos?.filter(
          (ubo) => UboCategoryMaster[ubo?.type] === UboCategoryMaster.individual
        ).length) ||
      (!decalaration?.nonIndividualUbo &&
        application?.ubos?.filter(
          (ubo) => UboCategoryMaster[ubo?.type] === UboCategoryMaster.non_individual
        ).length))
  ) {
    return true;
  } else if (
    checkIfSchemeNIDI2(application?.schemeId || '') &&
    checkValidationBasedOnDate(
      application?.createdAt || '',
      nidi2AInvestmentDeclarationStartDate
    ) &&
    !decalaration.nidi2AInvestmentDeclaration
  ) {
    return true;
  }
  return false;
};

export const getAuthorizedSignatoryDeclaration = (application: ApplicationProps): Declaration => {
  return {
    directInvestment:
      getAuthorisedSignatories(application)?.find((dec) => dec?.directInvestment)
        ?.directInvestment || false,
    indirectInvestment:
      getAuthorisedSignatories(application)?.find((dec) => dec?.indirectInvestment)
        ?.indirectInvestment || false,
    noIndividualOwnership:
      getAuthorisedSignatories(application)?.find((dec) => dec?.noIndividualOwnership)
        ?.noIndividualOwnership || false,
    individualUbo:
      getAuthorisedSignatories(application)?.find((dec) => dec?.individualUbo)?.individualUbo ||
      false,
    nonIndividualUbo:
      getAuthorisedSignatories(application)?.find((dec) => dec?.nonIndividualUbo)
        ?.nonIndividualUbo || false,
    nidi2AInvestmentDeclaration:
      getAuthorisedSignatories(application)?.find((dec) => dec?.nidi2AInvestmentDeclaration)
        ?.nidi2AInvestmentDeclaration || false,
  };
};

export default function AuthorizedSignatoriesInvestorApplication({
  location,
}: {
  location: Location<{
    topUpApplication: boolean;
  }>;
}): JSX.Element {
  const { referenceId } = useParams<{ referenceId: string }>();
  const { topUpApplication } = location.state;
  const dispatch = useDispatch();
  const history = useHistory();
  const { investor, auth } = useSelector((store: RootStateType) => store);
  const [application, setApplication] = useState<ApplicationProps>();
  const [loading, setLoading] = useState(false);
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [authorizedSignatory, setAuthorizedSignatory] = useState(initialValues);
  const [consentInfo, setConsentInfo] = useState('');
  const [loginSignatoryDeclaration, setLoginSignatoryDeclaration] = useState<Declaration>();
  const [nationalitiesMdmsMasters, setNationalitiesMdmsMasters] = useState<nationaliyType>(
    {} as nationaliyType
  );
  const { toggler } = useFeatureToggles();
  const [documentsResponse, setDocumentsResponse] = useState<Document>({} as Document);
  const [topupDocumentsResponse, setTopupDocumentsResponse] = useState<Document>({} as Document);
  const [riskProfile, setRiskProfile] = useState<RiskProfileMaster | undefined>(
    {} as RiskProfileMaster
  );
  const [brokerList, setBrokerList] = useState<BrokerList>({} as BrokerList);

  const validate = async (
    _application: ApplicationProps,
    risk: RiskProfileMaster | undefined,
    documentsResponse: Document,
    nationalitiesMdmsMasters: nationaliyType,
    broker_list: Broker[],
    verifyPennydrop = true
  ) => {
    if (checkIfApplicationIsNonIndividual(_application as ApplicationProps)) {
      const getInvestorType = _application?.applicants[0]?.investorType?.toString();
      const nonIndividualDoc =
        documentsResponse[
          `${
            checkIfApplicationIsNonIndividualPOA(_application as ApplicationProps)
              ? `${getInvestorType}_poa`
              : getInvestorType
          }`
        ];
      const nonIndividualTopupDocuments =
        topupDocumentsResponse[
          `${
            checkIfApplicationIsNonIndividualPOA(_application as ApplicationProps)
              ? `${getInvestorType}_poa`
              : getInvestorType
          }`
        ];
      await nonIndividualFormValidForSubmission(
        _application as ApplicationProps,
        risk,
        toggler,
        nonIndividualDoc as individuals_Poa_nonIndividuals_Documents[],
        nonIndividualTopupDocuments as individuals_Poa_nonIndividuals_Documents[],
        nationalitiesMdmsMasters?.countries,
        broker_list as Broker[],
        verifyPennydrop,
        auth.role
      );
    } else {
      await isFormValidForSubmission(
        _application as ApplicationProps,
        risk,
        true,
        verifyPennydrop,
        nationalitiesMdmsMasters,
        broker_list as Broker[],
        documentsResponse,
        auth.role,
        toggler
      );
    }
  };

  const { Document } = useMdmsDocumentData();
  const { TopUpDocument } = useMdmsTopUpDocumentData();
  const { countries } = useMdmsCountryData();
  const { riskProfile: _risk } = useMdmsRiskProfileData();
  const { BrokerList } = useMdmsBrokerListData();
  useEffect(() => {
    (async function () {
      try {
        const _application = (await dispatch(
          getApplicationDetailsWithRefId(referenceId, topUpApplication)
        )) as unknown as ApplicationProps;
        setApplication(_application);
      } catch (e) {
        typeof e === 'string' && setConsentInfo(e);
        console.error((e as Error).message);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  useEffect(() => {
    (async function () {
      try {
        setNationalitiesMdmsMasters(countries);
        setDocumentsResponse(Document);
        setTopupDocumentsResponse(TopUpDocument);
        setBrokerList(BrokerList);
        let risk;
        if (RiskProfileEnabled) {
          risk = _risk;
        }
        setRiskProfile(risk);
        if (application) {
          const signatoryDeclarations = getAuthorizedSignatoryDeclaration(application);
          setLoginSignatoryDeclaration(signatoryDeclarations);
          setAuthorizedSignatory(signatoryDeclarations);

          if (validDeclaration(signatoryDeclarations, application as ApplicationProps)) {
            if (!application?.signDetails?.url) {
              await validate(
                application as ApplicationProps,
                risk,
                documentsResponse,
                nationalitiesMdmsMasters,
                BrokerList.broker_list as Broker[],
                true
              );
            }
          }
        }
        throw '';
      } catch (e) {
        typeof e === 'string' && setConsentInfo(e);
        console.error((e as Error).message);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, [application, Document, TopUpDocument, countries, _risk, BrokerList]);

  // useEffect(() => {
  //   const { token } = investor;
  //   if (!token) {
  //     history.push(`/authorized-signatories-investment-details/${referenceId}/fund-details`);
  //   }
  // }, []);

  const handleEsign = async (values: Declaration) => {
    try {
      setIsSubmitting(true);
      const { id, signDetails } = application || {};
      if (signDetails?.url) {
        window.open(signDetails?.url, '_blank');
        return;
      }
      if (
        checkIfSchemeNIDI2(application?.schemeId || '') &&
        !values?.nidi2AInvestmentDeclaration &&
        checkValidationBasedOnDate(
          application?.createdAt || '',
          nidi2AInvestmentDeclarationStartDate
        )
      ) {
        throw new DeclarationErrors('Please accept NIDI 2A Declaration');
      }
      if (validDeclaration(values, application as ApplicationProps)) {
        throw `Please Provide Declaration`;
      }
      if (ESIGN_STATUS.NOT_GENERATED === application?.signDetails.status) {
        await validate(
          application as ApplicationProps,
          riskProfile,
          documentsResponse,
          nationalitiesMdmsMasters,
          brokerList.broker_list as Broker[],
          true
        );
      }
      let loginSignatory = getAuthorizedSignatoryDeclaration(application as ApplicationProps);
      setLoginSignatoryDeclaration(loginSignatory);
      if (id) {
        const applicationResponse = (!validDeclaration(values, application as ApplicationProps) &&
        validDeclaration(loginSignatory, application as ApplicationProps)
          ? await dispatch(
              provideConsentApplication({
                body: values,
                referenceId: referenceId,
              })
            )
          : application) as unknown as ApplicationProps;
        setApplication(applicationResponse);
        loginSignatory = getAuthorizedSignatoryDeclaration(applicationResponse);
        setLoginSignatoryDeclaration(loginSignatory);
        if (!validDeclaration(loginSignatory, applicationResponse)) {
          const response = (await dispatch(
            sendEsignAuthorised(referenceId)
          )) as unknown as esignApplicationResponse;

          setApplication({
            ...application,
            signDetails: response,
          } as unknown as ApplicationProps);
          window.open(response?.url, '_blank');
          return;
        } else {
          throw `failed to provide consent`;
        }
      }
    } catch (e) {
      if (e instanceof DeclarationErrors) {
        dispatch(showError((e as DeclarationErrors).message));
      }
      if (typeof e === 'string') {
        setConsentInfo(e);
        dispatch(showError(e as string));
      }
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Formik initialValues={authorizedSignatory} onSubmit={handleEsign} enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Box
          sx={{
            bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <IconButton
            sx={{
              position: 'fixed',
              right: 0,
              bottom: 75,
              borderRadius: '5px  0 0 5px',
              '&,:hover': {
                bgcolor: 'primary.main',
              },
            }}
            onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
            <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
          </IconButton>
          <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
            <Box>
              <CardMedia
                component="img"
                src="/images/nippon-logo.svg"
                alt="Nippon India Alternate Investments Logo"
                sx={{ width: { xs: '220px', sm: '300px' }, m: 3 }}
              />
            </Box>
          </AppBar>
          <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
          <Box sx={{ py: 5, px: { xs: 5, sm: 10 } }} ref={applicationDetailRef}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                mb: 2,
                justifyContent: 'space-between',
                mt: 10,
                flexDirection: { xs: 'column', sm: 'row' },
              }}>
              <Typography sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main', mb: 4 }}>
                Application Details
              </Typography>
            </Box>
            {loading && <LinearProgress />}
            {application && (
              <>
                {checkIfApplicationIsNonIndividual(application) ? (
                  <NonIndividualApplicationLayout
                    loading={loading}
                    application={application as ApplicationProps}
                  />
                ) : (
                  <ApplicationDetailsCommonLayout
                    loading={loading}
                    application={application as ApplicationProps}
                  />
                )}
                <Grid item xs={12}>
                  {!application?.distributor_id
                    ? checkforDirectInvestment(
                        application?.createdAt || '',
                        application?.distributorName
                      ) && (
                        <>
                          <SubHeading sx={styles.DeclarationHeading}>
                            Declaration for Direct Plan Investor
                          </SubHeading>
                          <MFCheckbox
                            name={`directInvestment`}
                            disabled={loginSignatoryDeclaration?.directInvestment as boolean}
                            label={esignDeclaration(DeclarationMaster.direct.directInvestment)}
                            sx={styles.DeclarationCheckboxStyle}
                            onChange={({ target: { checked } }) => {
                              setValues({
                                ...values,
                                directInvestment: checked,
                                indirectInvestment: false,
                              });
                            }}
                          />
                        </>
                      )
                    : !checkforDirectInvestment(
                        application?.createdAt || '',
                        application?.distributorName
                      ) && (
                        <>
                          <SubHeading sx={styles.DeclarationHeading}>
                            Declaration for Distributor Plan Investor
                          </SubHeading>
                          <MFCheckbox
                            name={`indirectInvestment`}
                            disabled={loginSignatoryDeclaration?.indirectInvestment as boolean}
                            label={esignDeclaration(DeclarationMaster.direct.indirectInvestment)}
                            sx={styles.DeclarationCheckboxStyle}
                            onChange={({ target: { checked } }) => {
                              setValues({
                                ...values,
                                indirectInvestment: checked,
                                directInvestment: false,
                              });
                            }}
                          />
                        </>
                      )}
                </Grid>
                {application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL && (
                  <>
                    <SubHeading sx={styles.DeclarationHeading}>UBO declaration</SubHeading>
                    {!application?.ubos?.length ? (
                      <Grid item xs={12}>
                        <MFCheckbox
                          name={`noIndividualOwnership`}
                          disabled={loginSignatoryDeclaration?.noIndividualOwnership as boolean}
                          label={esignDeclaration(DeclarationMaster.ubo.noIndividualOwnership)}
                          sx={styles.DeclarationCheckboxStyle}
                        />
                      </Grid>
                    ) : (
                      <>
                        {application?.ubos?.filter(
                          (ubo) => UboCategoryMaster[ubo?.type] === UboCategoryMaster.individual
                        ).length > 0 && (
                          <Grid item xs={12}>
                            <MFCheckbox
                              name={`individualUbo`}
                              disabled={loginSignatoryDeclaration?.individualUbo as boolean}
                              label={esignDeclaration(DeclarationMaster.ubo.individualUbo)}
                              sx={styles.DeclarationCheckboxStyle}
                            />
                          </Grid>
                        )}
                        {application?.ubos?.filter(
                          (ubo) => UboCategoryMaster[ubo?.type] === UboCategoryMaster.non_individual
                        )?.length > 0 && (
                          <Grid item xs={12}>
                            <MFCheckbox
                              name={`nonIndividualUbo`}
                              disabled={loginSignatoryDeclaration?.nonIndividualUbo as boolean}
                              label={esignDeclaration(DeclarationMaster.ubo.nonIndividualUbo)}
                              sx={styles.DeclarationCheckboxStyle}
                            />
                          </Grid>
                        )}
                      </>
                    )}
                  </>
                )}
                <Grid item xs={12}>
                  {checkIfSchemeNIDI2(application?.schemeId || '') &&
                    checkValidationBasedOnDate(
                      application?.createdAt || '',
                      nidi2AInvestmentDeclarationStartDate
                    ) && (
                      <MFCheckbox
                        name={`nidi2AInvestmentDeclaration`}
                        disabled={loginSignatoryDeclaration?.nidi2AInvestmentDeclaration as boolean}
                        label={
                          <>
                            <SubHeading sx={{ ...styles.DeclarationHeading, paddingLeft: '0px' }}>
                              Declaration with respect to investment in Nippon India Digital
                              Innovation AIF Scheme 2A (“Fund” or “NIDI 2A”)
                            </SubHeading>
                            <ListView
                              list={nidi2AInvestmentDeclarationNode}
                              disabled={
                                loginSignatoryDeclaration?.nidi2AInvestmentDeclaration as boolean
                              }
                            />
                          </>
                        }
                        sx={styles.DeclarationCheckboxStyle}
                      />
                    )}
                </Grid>
                {!isSubmitting && consentInfo && (
                  <Box sx={{ mt: 4 }}>
                    <Notes displayContent={consentInfo} />
                  </Box>
                )}
                {![ESIGN_STATUS.SIGNED, ESIGN_STATUS.EXPIRED].includes(
                  application?.signDetails?.status
                ) && (
                  <Box sx={{ textAlign: 'center' }}>
                    <LoadingButton
                      variant="contained"
                      loadingPosition="start"
                      type="submit"
                      sx={{
                        color: 'common.white',
                        minWidth: '200px',
                        mt: consentInfo ? 1 : 4,
                        fontWeight: 600,
                        lineHeight: 1.5,
                        px: 4,
                      }}
                      loading={isSubmitting}>
                      {'e-Sign'}
                    </LoadingButton>
                  </Box>
                )}
              </>
            )}
          </Box>
          <Footer />
          <Dialog
            open={isSubmitting}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle sx={{ textAlign: 'center' }} id="alert-dialog-title">
              {'Please Wait'}
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', px: 8 }}>
              <DialogContentText sx={{ mb: 4 }} id="alert-dialog-description">
                Don&#39;t refresh or click on back button
              </DialogContentText>
              <CircularProgress />
            </DialogContent>
          </Dialog>
        </Box>
      )}
    </Formik>
  );
}
